/* Region select */
(function($) {

  function supports_history_api() {
      return !!(window.history && history.pushState);
      }

      function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
      }

  function document_to_dom_object(data) {
      return $($.trim(String(data)
              .replace(/<\!DOCTYPE[^>]*>/i, '')
              .replace(/<(html|head|body|title|meta|script)([\s\>])/gi,'<div class="document-$1"$2')
              .replace(/<\/(html|head|body|title|meta|script)\>/gi,'</div>')));
      }

  var rswitcherSelector = '.js-region-switcher';
  var rmenuSelector = '.js-region-list';

  function regionSwitcher(el) {
    var menu = el.find(rmenuSelector);

    function onOutsideClick(event) {
      event.preventDefault();
      var target = $(event.target);
      if( !target.closest(rswitcherSelector).length > 0 ) {
        closeMenu();
      }
    }

    function closeMenu() {
      el.removeClass('open');
      $(document).off('click touchstart', onOutsideClick);
    }

    function openMenu() {
      el.addClass('open');
      $(document).on('click touchstart', onOutsideClick);
    }

    el.on('click touchstart', function(e) {

      var target = $(e.target);

      // when <li> or its children haven't been clicked
      if(!target.is('li') && !target.parents('li').length) {

        e.stopPropagation();
        e.preventDefault();

        if(el.hasClass('open')) {
          closeMenu();
        } else {
          openMenu();
        }

      }

    });
  }

  function initregionSwitcher() {
    var switcher = $('.region-switcher');
    if(!switcher.length) {
      return;
    }
    switcher.each(function() {
      regionSwitcher($(this));
    });
  }

  initregionSwitcher();


    $('body').on('click', '.js-region-switcher li', function(ee){
      ee.preventDefault();
     // console.log(ee);
      var $regdestination = $('.js-grid-errors');
      var $selection = $('.js-region-switcher');
      var $myselection = $('#errors');
      $regdestination.addClass('loading');
      $selection.addClass('loading');
      $selection.removeClass('open');

      var url = $(this).children().attr('href');
      //console.log(url);
      $(this).blur();
      $.ajax({
        url: url,
        success: function(data, textStatus, jqXHR){

          // Prepare
          var $data = document_to_dom_object(data);
          var $dataBody = $data.find('.document-body:first');
          var $content = $dataBody.find('.js-grid-errors');
          var $new_selection = $dataBody.find('.js-region-switcher');
          var $myselect = $dataBody.find('.error');

          if(supports_history_api) {

            window.history.replaceState(url, document.title, url);

          }

          // insert more items
          $regdestination.html($content.children());
          $selection.html($new_selection.children());
          setTimeout(function() {
            $('.js-grid-errors').removeClass('loading');
            $('.js-region-switcher').removeClass('loading');
          }, 250);

        },
        error: function(jqXHR, textStatus, errorThrown){
         // console.log(jqXHR);
          //document.location.href = url;
          return false;
        }
      }); // end ajax


      $($myselection).on("click", ".error", function (event) {
          event.preventDefault();
          event.target.closest('.error').classList.toggle('open');
      });

  });

    function initQA() {
      var qaItems = document.querySelectorAll('.error');
      if(qaItems.length) {
        [].slice.call(qaItems).forEach(function(item) {
          item.addEventListener('click', function(e) {
            e.preventDefault();
            e.target.closest('.error').classList.toggle('open');
          }, false);
        });
      }
    }

    initQA();

  })(jQuery);
